import { StrictLocalizeFunction } from "@faire/web--source/common/localization";
import validateUrlApi from "@faire/web-api--source/api/brand-lead/validate-url/post";
import validate from "validate.js";

export enum SIGNUP_FORM_STAGE {
  SIGNUP,
  CREATE_ACCOUNT,
}

export const BRAND_SIGN_UP_VALIDATION_RULES = (
  strictLocalize: StrictLocalizeFunction
) => ({
  email: { presence: { allowEmpty: false }, email: true },
  companyName: {
    presence: {
      allowEmpty: false,
      message:
        "^" +
        strictLocalize({
          defaultMessage: "Brand name can't be blank",
          description: {
            text: "Error message informing the user to input their brand name",
          },
        }),
    },
  },
  numProducts: {
    presence: {
      allowEmpty: false,
      message:
        "^" +
        strictLocalize({
          defaultMessage:
            "Please specify the number of wholesale products you sell",
          description: {
            text: "An error message displayed to the user if they have not selected a value from the drop-down that is used to specify the number of wholesale products they sell.",
          },
        }),
    },
  },
  stockists: {
    presence: {
      allowEmpty: false,
      message:
        "^" +
        strictLocalize({
          defaultMessage:
            "Please specify the number of independent stores you work with",
          description: {
            text: "An error message displayed to the user if they have not selected a value from the drop-down that is used to specify the number of independent stores they work with.",
          },
        }),
    },
  },
  "country.isoCode": {
    presence: {
      allowEmpty: false,
      message:
        "^" +
        strictLocalize({
          defaultMessage: "Please select a valid country",
          description: {
            text: "An error message displayed to the user if the country that their brand belongs to is not recognized.",
          },
        }),
    },
  },
  categoryOption: {
    presence: {
      allowEmpty: false,
      message:
        "^" +
        strictLocalize({
          defaultMessage: "Category can't be blank",
          description: {
            text: "Error message informing the user to input their company selling category",
          },
        }),
    },
  },
});

export const validateUrlWithErrors = (
  value: string,
  strictLocalize: StrictLocalizeFunction
): Promise<string> =>
  new Promise((resolve) => {
    if (validate.isEmpty(value)) {
      return resolve(
        strictLocalize({
          defaultMessage: "Website URL is required",
          description: {
            text: "Websiste URL is required when submitting the form",
          },
        })
      );
    }

    return validateUrlApi(value)
      .then((response) => {
        if (response) {
          resolve("");
        } else {
          resolve(
            strictLocalize({
              defaultMessage: "Please enter a functional website URL",
            })
          );
        }
      })
      .catch(() =>
        resolve(
          strictLocalize({
            defaultMessage: "Please enter a functional website URL",
          })
        )
      );
  });

export const MAKER_SIGN_UP_BASED_IN_STORAGE_KEY = "makerSignUpBasedIn";
